import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chin_strap_thumbnail.png'


const _withScopeId = n => (_pushScopeId("data-v-4782e1ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "step-number" }, "STEP 1"),
  /*#__PURE__*/_createElementVNode("span", { class: "step-description" }, "PICK A TEMPLATE")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chin Strap", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.chinStrapAddon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Checkbox, {
            modelValue: _ctx.chinStrapAddonState,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chinStrapAddonState) = $event)),
            binary: true,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChinStrapCheckboxChange()))
          }, null, 8, ["modelValue"]),
          _hoisted_4,
          _createElementVNode("small", null, " + $" + _toDisplayString(_ctx.chinStrapAddon.price) + " extra", 1),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.activeProduct.type === 'truckercap'
          ? `templates-${_ctx.activeProduct.type}`
          : 'templates',
      ])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productTemplates, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (_ctx.changeActiveTemplate(item)),
          key: item.id,
          class: _normalizeClass([
          item.product === 'scarf' ? `image-wrapper-${item.product}` : '',
          item.product === 'truckercap' ? `image-wrapper-${item.product}` : '',
          'image-wrapper',
        ])
        }, [
          (item.alias === _ctx.activeProduct.alias)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.alias), {
                key: 0,
                id: "svg-front",
                text: _ctx.activeProduct.text,
                productColors: _ctx.activeProduct.colors,
                logo: _ctx.activeProduct.logo,
                cheetaLogo: _ctx.activeProduct.cheetaLogo,
                details: _ctx.activeProduct.details
              }, null, 8, ["text", "productColors", "logo", "cheetaLogo", "details"]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: item.pathToImage,
                alt: ""
              }, null, 8, _hoisted_7))
        ], 10, _hoisted_6))
      }), 128))
    ], 2)
  ]))
}